import app from './public.js';

function IsLeapYear(iYear) {
  if (iYear % 4 == 0 && iYear % 100 != 0) {
    return true;
  } else {
    if (iYear % 400 == 0) {
      return true;
    } else {
      return false;
    }
  }
}

//---------------------------------------------------
// 日期格式化
// 格式 YYYY/yyyy/YY/yy 表示年份
// MM/M 月份
// W/w 星期
// dd/DD/d/D 日期
// hh/HH/h/H 时间
// mm/m 分钟
// ss/SS/s/S 秒
//---------------------------------------------------
function DateFormat(formatStr, datestr) {
  var date = new Date(datestr);
  var str = formatStr;
  var Week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  str = str.replace(/yyyy|YYYY/, date.getFullYear());
  str = str.replace(
    /yy|YY/,
    date.getYear() % 100 > 9 ? (date.getYear() % 100).toString() : '0' + (date.getYear() % 100),
  );
  str = str.replace(/MM/, date.getMonth() > 8 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1));
  str = str.replace(/M/g, date.getMonth());
  str = str.replace(/w|W/g, Week[date.getDay()]);
  str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate());
  str = str.replace(/d|D/g, date.getDate());
  str = str.replace(/hh|HH/, date.getHours() > 9 ? date.getHours().toString() : '0' + date.getHours());
  str = str.replace(/h|H/g, date.getHours());
  str = str.replace(/mm/, date.getMinutes() > 9 ? date.getMinutes().toString() : '0' + date.getMinutes());
  str = str.replace(/m/g, date.getMinutes());
  str = str.replace(/ss|SS/, date.getSeconds() > 9 ? date.getSeconds().toString() : '0' + date.getSeconds());
  str = str.replace(/s|S/g, date.getSeconds());
  return str;
}
//+---------------------------------------------------
//| 求两个时间的天数差 日期格式为 YYYY-MM-dd
//+---------------------------------------------------
function daysBetween(DateOne, DateTwo) {
  var OneMonth = DateOne.substring(5, DateOne.lastIndexOf('-'));
  var OneDay = DateOne.substring(DateOne.length, DateOne.lastIndexOf('-') + 1);
  var OneYear = DateOne.substring(0, DateOne.indexOf('-'));

  var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf('-'));
  var TwoDay = DateTwo.substring(DateTwo.length, DateTwo.lastIndexOf('-') + 1);
  var TwoYear = DateTwo.substring(0, DateTwo.indexOf('-'));

  var cha =
    (Date.parse(OneMonth + '/' + OneDay + '/' + OneYear) - Date.parse(TwoMonth + '/' + TwoDay + '/' + TwoYear)) /
    86400000;
  return Number(cha);
}
//+---------------------------------------------------
//| 日期计算
//+---------------------------------------------------
function DateAdd(strInterval, Number, dateStr) {
  var dtTmp = dateStr;
  switch (strInterval) {
    case 's':
      return new Date(Date.parse(dtTmp) + 1000 * Number);
    case 'n':
      return new Date(Date.parse(dtTmp) + 60000 * Number);
    case 'h':
      return new Date(Date.parse(dtTmp) + 3600000 * Number);
    case 'd':
      return new Date(Date.parse(dtTmp) + 86400000 * Number);
    case 'w':
      return new Date(Date.parse(dtTmp) + 86400000 * 7 * Number);
    case 'q':
      return new Date(
        dtTmp.getFullYear(),
        dtTmp.getMonth() + Number * 3,
        dtTmp.getDate(),
        dtTmp.getHours(),
        dtTmp.getMinutes(),
        dtTmp.getSeconds(),
      );
    case 'm':
      return new Date(
        dtTmp.getFullYear(),
        dtTmp.getMonth() + Number,
        dtTmp.getDate(),
        dtTmp.getHours(),
        dtTmp.getMinutes(),
        dtTmp.getSeconds(),
      );
    case 'y':
      return new Date(
        dtTmp.getFullYear() + Number,
        dtTmp.getMonth(),
        dtTmp.getDate(),
        dtTmp.getHours(),
        dtTmp.getMinutes(),
        dtTmp.getSeconds(),
      );
  }
}
//+---------------------------------------------------
//| 取得日期数据信息
//| 参数 interval 表示数据类型
//| y 年 m月 d日 w星期 ww周 h时 n分 s秒
//+---------------------------------------------------
function DatePart(interval, datestr) {
  var myDate = new Date(datestr);
  var partStr = '';
  var Week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  switch (interval) {
    case 'y':
      partStr = myDate.getFullYear();
      break;
    case 'm':
      partStr = myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1;
      break;
    case 'd':
      partStr = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
      break;
    case 'w':
      partStr = Week[myDate.getDay()];
      break;
    case 'ww':
      partStr = myDate.WeekNumOfYear();
      break;
    case 'h':
      partStr = myDate.getHours();
      break;
    case 'n':
      partStr = myDate.getMinutes();
      break;
    case 's':
      partStr = myDate.getSeconds();
      break;
  }
  return partStr;
}

//+---------------------------------------------------
//| 取得当前日期所在月的最大天数
//+---------------------------------------------------
function MaxDayOfDate(dateStr) {
  var myDate = dateStr;
  var ary = DatetoArray(myDate);
  month = parseInt(ary[1], 10);
  var d = new Date(ary[0], ary[1], 0);
  return d.getDate();
}

//+---------------------------------------------------
//| 把日期分割成数组
//+---------------------------------------------------
function DatetoArray(dateStr) {
  var myDate = new Date(dateStr);
  var myArray = Array();
  myArray[0] = myDate.getFullYear();
  myArray[1] = myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1;
  myArray[2] = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
  myArray[3] = myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours();
  myArray[4] = myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes();
  myArray[5] = myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds();
  return myArray;
}

function getCurrentMonthFirst(dateStr) {
  var date = new Date(dateStr);
  date.setDate(1);
  return date;
}

function DateToWeek(dateStr, SystemTime) {
  //	var starts = dateStr.toLocaleDateString();
  // 	var ends = SystemTime.toLocaleDateString();
  // 	var iday = datedifference(starts, ends);
  // 	if (iday == 0) {
  // 		return "今天";
  // 	} else if (iday == 1) {
  // 		return "明天";
  // 	} else {
  var Week = ['日', '一', '二', '三', '四', '五', '六'];
  if (typeof dateStr == 'String' || typeof dateStr == 'string') {
    return '周' + Week[new Date(dateStr.replace(/-/g, '/')).getDay()];
  } else {
    return '周' + Week[dateStr.getDay()];
  }
  //}
}

function DateToWeekToday(dateStr, SystemTime) {
  var starts = dateStr; //.toLocaleDateString()
  var ends = SystemTime; //.toLocaleDateString()
  var iday = datedifference(starts, ends);
  if (iday == 0) {
    return '今天';
  } else if (iday == 1) {
    return '明天';
  } else {
    var Week = ['日', '一', '二', '三', '四', '五', '六'];
    if (typeof dateStr == 'String' || typeof dateStr == 'string') {
      return '周' + Week[new Date(dateStr.replace(/-/g, '/')).getDay()];
    } else {
      return '周' + Week[dateStr.getDay()];
    }
  }
}

function InternationalDateToWeek(dateStr) {
  var Week = ['日', '一', '二', '三', '四', '五', '六'];
  if (typeof dateStr == 'String' || typeof dateStr == 'string') {
    return '周' + Week[new Date(dateStr.replace(/-/g, '/')).getDay()];
  } else {
    return '周' + Week[dateStr.getDay()];
  }
}

function datedifference(sDate1, sDate2) {
  //sDate1和sDate2是2006-12-18格式
  var dateSpan, tempDate, iDays;
  var starts = DatetoArray(sDate1.toString().replace(/-/g, '/'));
  var ends = DatetoArray(sDate2.toString().replace(/-/g, '/'));

  var start = starts[0] + '/' + starts[1] + '/' + starts[2];
  var end = ends[0] + '/' + ends[1] + '/' + ends[2];

  sDate1 = Date.parse(start);
  sDate2 = Date.parse(end);
  dateSpan = sDate2 - sDate1;
  dateSpan = Math.abs(dateSpan);

  iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
  return iDays;
}

function formatDate(date, fmt) {
  var datetime = new Date(date.replace(/-/g, '/'));
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (datetime.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': datetime.getMonth() + 1,
    'd+': datetime.getDate(),
    'h+': datetime.getHours(),
    'm+': datetime.getMinutes(),
    's+': datetime.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

function FomartDateStr(sDate1, sDate2) {
  var str = '';

  var iDays = datedifference(sDate1, sDate2);

  if (iDays > 0) {
    str = '+' + iDays + '天';
  }
  return str;
}
// 把标准时间转化为 年-月-日 时:分:秒 格式
function changeDate(date) {
  let newDate = new Date(date);
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  let D = date.getDate() + ' ';
  let h = date.getHours() + ':';
  let m = date.getMinutes() + ':';
  let s = date.getSeconds();
  return Y + M + D + h + m + s;
}
// 检验机票缓存时期是都过期
function checkDate(sysDate, isInternational) {
  let settings = app.GetSettings();
  let DepartDateJson = settings.DepartDateFlightJson;
  let ArriveDateJson = settings.backDepartDateFlightJson;
  if (!DepartDateJson || !DepartDateJson.fulldate) {
    DepartDateJson = {
      fulldate: formatDate(changeDate(sysDate).replace(/-/g, '/'), 'yyyy-MM-dd'),
      week: '今天',
    };
    let arrDate = changeDate(DateAdd('d', 1, sysDate)).replace(/-/g, '/');
    ArriveDateJson = {
      fulldate: formatDate(arrDate, 'yyyy-MM-dd'),
      week: '明天',
    };
    if (isInternational) {
      DepartDateJson.week = InternationalDateToWeek(new Date(sysDate));
      ArriveDateJson.week = InternationalDateToWeek(new Date(arrDate));
    }
  } else {
    let hdate = DepartDateJson.fulldate;
    let ndate = new Date(hdate.replace(/-/g, '/'));
    let newDate;
    if (ndate.getTime() < sysDate.getTime()) {
      newDate = changeDate(sysDate).replace(/-/g, '/');
    } else {
      newDate = hdate.replace(/-/g, '/');
    }
    DepartDateJson = {
      fulldate: formatDate(newDate, 'yyyy-MM-dd'),
      week: DateToWeek(new Date(newDate), sysDate),
    };
    let arrDate;
    if (ArriveDateJson) {
      if (new Date(ArriveDateJson.fulldate).getTime() <= sysDate.getTime()) {
        arrDate = changeDate(DateAdd('d', 1, sysDate)).replace(/-/g, '/');
      } else {
        if (new Date(ArriveDateJson.fulldate).getTime() >= new Date(DepartDateJson.fulldate.replace(/-/g, '/'))) {
          arrDate = ArriveDateJson.fulldate.replace(/-/g, '/');
        } else {
          arrDate = changeDate(DateAdd('d', 1, new Date(DepartDateJson.fulldate.replace(/-/g, '/')))).replace(
            /-/g,
            '/',
          );
        }
      }
    } else {
      arrDate = changeDate(DateAdd('d', 1, sysDate)).replace(/-/g, '/');
    }
    ArriveDateJson = {
      fulldate: formatDate(arrDate, 'yyyy-MM-dd'),
      week: DateToWeek(new Date(arrDate), sysDate),
    };
    if (isInternational) {
      DepartDateJson.week = InternationalDateToWeek(new Date(newDate));
      ArriveDateJson.week = InternationalDateToWeek(new Date(arrDate));
    }
  }
  settings.DepartDateFlightJson = DepartDateJson;
  settings.backDepartDateFlightJson = ArriveDateJson;
  app.SetSettings(settings);
}
export default {
  IsLeapYear: IsLeapYear,
  DateFormat: DateFormat,
  daysBetween: daysBetween,
  DateAdd: DateAdd,
  DatePart: DatePart,
  MaxDayOfDate: MaxDayOfDate,
  DatetoArray: DatetoArray,
  getCurrentMonthFirst: getCurrentMonthFirst,
  DateToWeek: DateToWeek,
  datedifference: datedifference,
  formatDate: formatDate,
  FomartDateStr: FomartDateStr,
  checkDate: checkDate,
  InternationalDateToWeek: InternationalDateToWeek,
  DateToWeekToday: DateToWeekToday,
  changeDate: changeDate,
};
